import * as UI from "@iyk/ui"
import * as ContactForm from "./contact-form.tsx"

import { useActionData } from "@remix-run/react"
import { SectionLayout } from "./ui/section-layout.tsx"

export const LandingContactForm = ({ className, ...props }: UI.HTMLElementProps) => {
  const action = useActionData()
  const isSubmitted = action !== undefined

  return (
    <SectionLayout
      id="custom-form"
      size="fluid"
      theme="dark"
      className={UI.cx(
        "flex flex-col items-center md:flex-row pt-[68px] pb-[52px] px-4 text-gray-12-dark bshadow-b bshadow-gray-6-dark",
        className,
      )}
      {...props}
    >
      <div className="md:w-[50%] flex justify-center">
        <div className={UI.classForStack({ className: "w-min" })}>
          <Card
            className={UI.classForLayer({
              className: "w-[252px] md:w-80 [aspect-ratio:9/14]",
            })}
          />
          <div
            className={UI.classForLayer({
              className: "self-center justify-self-center pr-[35px] text-xs-upper",
            })}
            aria-hidden="true"
          >
            <UI.Typewriter
              loop
              texts={[
                "your image here",
                "birthday wishes",
                "happy valentines",
                "a new baby",
                "thank you",
                "good luck",
                "congratulations",
                "seasons greetings",
              ]}
            />
          </div>
        </div>
      </div>

      <div className="md:w-[50%] flex justify-center">
        <div className="md:w-[380px]">
          <UI.Stack>
            <UI.Layer className={classForLayer({ isHidden: isSubmitted })}>
              <h3 className="text-xs-upper text-center pt-12 md:pt-0">for brands</h3>

              <p className="mt-2 text-sm text-center text-balance">
                Interested in creating a custom cyberphysical card for your brand? Fill out the form
                and we’ll get in touch.
              </p>

              <ContactForm.Root prefixId="custom-postcard-form">
                <div className="flex flex-row gap-4">
                  <ContactForm.FirstName className="w-1/2" />
                  <ContactForm.LastName className="w-1/2" />
                </div>
                <ContactForm.Quantity />
                <ContactForm.Email />
                <ContactForm.Message />
                <ContactForm.SmallSubmitButton>Submit</ContactForm.SmallSubmitButton>
              </ContactForm.Root>
            </UI.Layer>
            <UI.Layer
              className={classForLayer({
                isHidden: !isSubmitted,
                className: "grid place-content-center",
              })}
            >
              <ContactForm.SuccessBlock />
            </UI.Layer>
          </UI.Stack>
        </div>
      </div>
    </SectionLayout>
  )
}

const classForLayer = UI.cva(["transition-all"], {
  variants: {
    isHidden: { true: "invisible pointer-events-none opacity-0" },
  },
})

// #region Card

const Card = (props: UI.SVGElementProps) => (
  <svg viewBox="0 0 324 495" fill="none" aria-hidden="true" {...props}>
    <path fill="#121212" d="M57.4 27.4h265.2v433.2H57.4z"></path>
    <path stroke="#606060" fill="none" strokeWidth="1.2" d="M57.4 27.4h265.2v433.2H57.4z"></path>
    <path
      stroke="#606060"
      fill="none"
      strokeWidth="1.2"
      d="M322.5 28 195.2 247.4c-.5.9-.5 2 0 2.8L322.7 460"
    ></path>
    <g filter="url(#a)">
      <path fill="#121212" d="M1 9h286v469H1z" shapeRendering="crispEdges"></path>
      <path stroke="#606060" fill="none" d="M.5 8.5h287v470H.5z" shapeRendering="crispEdges"></path>
      <path stroke="#818181" fill="none" d="M41 41h-8v8m8 397h-8v-8M255 49v-8h-8m8 397v8h-8"></path>
    </g>
    <defs>
      <filter
        id="a"
        width="316"
        height="495"
        x="0"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dx="16" dy="4"></feOffset>
        <feGaussianBlur stdDeviation="6"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.6 0"></feColorMatrix>
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1_22"></feBlend>
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1_22" result="shape"></feBlend>
      </filter>
    </defs>
  </svg>
)

// #endregion
